export default "__VITE_ASSET__CxTz9z7J__"